import React from "react";
import { useTheme } from "@emotion/react";

interface SizeData {
  type: string;
  size: string;
}

interface ProductSizeProps {
  size: string;
  c_size?: string;
  sizeSchema?: string;
  defaultColor?: string;
  toneColor?: string;
}

export const ProductSize: React.FC<ProductSizeProps> = ({
  size,
  c_size,
  sizeSchema,
  defaultColor,
  toneColor,
}) => {
  const theme = useTheme();

  const renderDefaultSize = () => {
    return (
      <>
        <span
          style={{
            color: defaultColor || theme.colors.tone.anthraciteDark,
          }}
        >
          {size}
        </span>{" "}
      </>
    );
  };

  const renderSize = () => {
    if (!c_size) {
      return renderDefaultSize();
    }

    try {
      const parsedSize = JSON.parse(c_size) as SizeData[];
      if (Array.isArray(parsedSize) && parsedSize.length > 0) {
        const firstSize = parsedSize[0];
        return (
          <>
            <span
              style={{
                color: defaultColor || theme.colors.tone.anthraciteDark,
              }}
            >
              {size}
            </span>{" "}
            {sizeSchema && (
              <span
                style={{
                  color: toneColor || theme.colors.tone.anthraciteLight,
                }}
              >
                {sizeSchema}
              </span>
            )}{" "}
            /{" "}
            <span
              style={{
                color: defaultColor || theme.colors.tone.anthraciteDark,
              }}
            >
              {firstSize.size}
            </span>{" "}
            {firstSize.type && (
              <span
                style={{
                  color: toneColor || theme.colors.tone.anthraciteLight,
                }}
              >
                {firstSize.type}
              </span>
            )}
          </>
        );
      }
    } catch (error) {
      console.error("Error parsing c_size:", error);
      return renderDefaultSize();
    }

    return renderDefaultSize();
  };

  return renderSize();
};

export default ProductSize;
